var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftT(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4779 24.8088C12.696 24.7178 12.8383 24.5056 12.8383 24.27L12.8383 17.8799L27.4168 17.8799C27.7387 17.8799 28 17.6187 28 17.2968L28 7.96648C28 7.64459 27.7387 7.38332 27.4168 7.38332L12.8383 7.38332L12.8383 0.968775C12.8383 0.733203 12.696 0.520921 12.479 0.429951C12.261 0.340129 12.0102 0.389113 11.8434 0.55591L0.171218 12.1896C0.0616049 12.2992 -0.000225594 12.4474 -0.000225601 12.6025C-0.000225608 12.7576 0.0616049 12.9057 0.17007 13.0153L11.8422 24.6828C12.0091 24.8496 12.2598 24.8998 12.4779 24.8088Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftT);
export default __webpack_public_path__ + "static/media/leftT.d4d83f8f16721af9078f24461a0bfd80.svg";
export { ForwardRef as ReactComponent };